<template>
  <div id="gw" class="goods-wrapper">
    <div class="loading-message" v-if="isLoading && goods.length === 0">
      Подождите, идет загрузка товаров...
    </div>
<!--    <div class="api-error" v-if="apiErrorMessage.length > 0">{{ apiErrorMessage }}</div>-->
    <div class="head">
      <div
        class="filters-wrapper"
        :class="{active: menuOpened}"
      >
        <button
          class="nav-tgl"
          :class="{opened: menuOpened}"
          @click="toggleMenu"
        >
          <svg
            id="Capa_1"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 480.3 480.3"
            style="enable-background:new 0 0 480.3 480.3;"
            xml:space="preserve"
          >
            <path
              d="M254.15,234.1V13.5c0-7.5-6-13.5-13.5-13.5s-13.5,6-13.5,13.5v220.6c-31.3,6.3-55,34-55,67.2s23.7,60.9,55,67.2v98.2
            c0,7.5,6,13.5,13.5,13.5s13.5-6,13.5-13.5v-98.2c31.3-6.3,55-34,55-67.2C309.15,268.2,285.55,240.4,254.15,234.1z M240.65,342.8
            c-22.9,0-41.5-18.6-41.5-41.5s18.6-41.5,41.5-41.5s41.5,18.6,41.5,41.5S263.55,342.8,240.65,342.8z"
            />
            <path
              d="M88.85,120.9V13.5c0-7.5-6-13.5-13.5-13.5s-13.5,6-13.5,13.5v107.4c-31.3,6.3-55,34-55,67.2s23.7,60.9,55,67.2v211.4
            c0,7.5,6,13.5,13.5,13.5s13.5-6,13.5-13.5V255.2c31.3-6.3,55-34,55-67.2S120.15,127.2,88.85,120.9z M75.35,229.6
            c-22.9,0-41.5-18.6-41.5-41.5s18.6-41.5,41.5-41.5s41.5,18.6,41.5,41.5S98.15,229.6,75.35,229.6z"
            />
            <path
              d="M418.45,120.9V13.5c0-7.5-6-13.5-13.5-13.5s-13.5,6-13.5,13.5v107.4c-31.3,6.3-55,34-55,67.2s23.7,60.9,55,67.2v211.5
            c0,7.5,6,13.5,13.5,13.5s13.5-6,13.5-13.5V255.2c31.3-6.3,55-34,55-67.2S449.85,127.2,418.45,120.9z M404.95,229.6
            c-22.9,0-41.5-18.6-41.5-41.5s18.6-41.5,41.5-41.5s41.5,18.6,41.5,41.5S427.85,229.6,404.95,229.6z"
            />
          </svg>
        </button>
        <nav class="nav">
          <div class="bg">
            <ul class="menu-items">
              <li :key="'all'">
                <label class="mik-checkbox">
                  <input type="checkbox"
                         :id="'all'"
                         :value="true"
                         v-model="selectAllCategories">
                  <span class="checkbox"></span>
                </label>
                <span class="category-name">Все</span>
              </li>
              <li v-for="(category) in categories" :key="category.id">
                <label class="mik-checkbox">
                  <input type="checkbox"
                         :id="category.id"
                         :value="category.id"
                         v-model="selectedCategories">
                  <span class="checkbox"></span>
                </label>
                <span class="category-name">{{ category.category }}</span>
              </li>
            </ul>
            <div class="filters-buttons">
              <MtButton class="filter-btn cancel" type="button" color="primary-invent" @click="resetFilters()">
                <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                     viewBox="0 0 47.971 47.971" style="enable-background:new 0 0 47.971 47.971;" xml:space="preserve">
                  <path d="M28.228,23.986L47.092,5.122c1.172-1.171,1.172-3.071,0-4.242c-1.172-1.172-3.07-1.172-4.242,0L23.986,19.744L5.121,0.88
                    c-1.172-1.172-3.07-1.172-4.242,0c-1.172,1.171-1.172,3.071,0,4.242l18.865,18.864L0.879,42.85c-1.172,1.171-1.172,3.071,0,4.242
                    C1.465,47.677,2.233,47.97,3,47.97s1.535-0.293,2.121-0.879l18.865-18.864L42.85,47.091c0.586,0.586,1.354,0.879,2.121,0.879
                    s1.535-0.293,2.121-0.879c1.172-1.171,1.172-3.071,0-4.242L28.228,23.986z"/>
                </svg>
              </MtButton>
              <MtButton class="filter-btn ok" type="button" @click="loadGoodsByFilters()">
                <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                     viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                  <path d="M504.502,75.496c-9.997-9.998-26.205-9.998-36.204,0L161.594,382.203L43.702,264.311c-9.997-9.998-26.205-9.997-36.204,0
                      c-9.998,9.997-9.998,26.205,0,36.203l135.994,135.992c9.994,9.997,26.214,9.99,36.204,0L504.502,111.7
                      C514.5,101.703,514.499,85.494,504.502,75.496z"/>
                </svg>
              </MtButton>
            </div>
          </div>
        </nav>
      </div>
      <div class="title">
        Продукция
      </div>
    </div>

    <div class="goods">
      <GoodsCard
        v-for="(g) in goods"
        :key="g.name"
        :goodsVal="g"/>
    </div>

    <MtButton class="go-to-top-button" color="primary-invent" type="button"
              v-if="contentScrolled" :class="{shown: contentScrolled}" @click="backToTop">
      <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
           viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
        <path d="M509.121,372.083l-246.17-246.175c-3.684-3.684-10.209-3.684-13.893,0L2.878,372.083c-3.838,3.838-3.838,10.055,0,13.893
          c3.838,3.838,10.055,3.838,13.893,0l239.234-239.229l239.224,239.228c1.919,1.919,4.433,2.878,6.946,2.878
          c2.514,0,5.028-0.959,6.946-2.878C512.959,382.139,512.959,375.921,509.121,372.083z"/>
      </svg>
    </MtButton>
  </div>
</template>

<script>
import GoodsCard from './GoodsCard'
import { mapState } from 'vuex'
import MtButton from '../MtButton/MtButton'

export default {
  name: 'Goods',
  components: { MtButton, GoodsCard },
  data () {
    return {
      menuOpened: false,
      allSelectedCategories: [],
      isAllSelected: false,
      contentScrolled: false
    }
  },
  watch: {
    $route (to, from) {
      const filters = this.$route.query.filters
      if (!filters) {
        this.allSelectedCategories.splice(0, this.allSelectedCategories.length)
        this.$store.dispatch('getInitialData')
      }
    }
  },
  created () {
    const filters = this.$route.query.filters
    if (filters && typeof filters === 'string') {
      this.allSelectedCategories = JSON.parse(filters)
      this.$store.dispatch('getAllCategories')
      this.$store.dispatch('getGoodsByCategories', this.allSelectedCategories)
    } else {
      // убрать
      // this.$store.commit('setGoods', [])
      this.$store.dispatch('getInitialData')
      this.allSelectedCategories = []
    }
  },
  mounted () {
    let gw = document.getElementById('gw')
    if (gw) {
      gw.parentElement.addEventListener('scroll', e => this.onContentScroll(e), false)
    }
  },
  beforeDestroy () {
    let gw = document.getElementById('gw')
    if (gw) {
      gw.parentElement.removeEventListener('scroll', e => this.onContentScroll(e))
    }
  },
  computed: {
    ...mapState({
      goods: state => state.goods.allGoods,
      categories: state => state.goods.categories,
      isLoading: state => state.goods.isLoading,
      apiErrorMessage: state => state.goods.apiErrorMessage
    }),

    selectAllCategories: {
      get () {
        if (this.allSelectedCategories.length !== this.categories.map(c => c.id).length) {
          return false
        }
        return this.isAllSelected
      },
      set (val) {
        this.isAllSelected = val
        if (val) {
          this.selectedCategories = this.categories.map(c => c.id)
          return
        }
        this.$router.push({ path: '/goods' })
        this.selectedCategories = []
      }
    },
    selectedCategories: {
      get () {
        return this.allSelectedCategories === null ? [] : this.allSelectedCategories
      },
      set (val) {
        this.allSelectedCategories = val
        this.$router.push({ path: '/goods', query: { filters: JSON.stringify(this.allSelectedCategories) } })
        if (val && val.length === 0) {
          this.$router.push({ path: '/goods' })
          this.$store.dispatch('getInitialData')
        }
      }
    }
  },
  methods: {
    loadGoodsByFilters () {
      this.$store.dispatch('getGoodsByCategories', this.allSelectedCategories)
      this.toggleMenu()
    },
    onContentScroll (event) {
      this.contentScrolled = event.target.scrollTop > 200
    },
    backToTop () {
      document.getElementById('gw').parentElement.scrollTop = 0
    },
    resetFilters () {
      this.selectedCategories = []
      this.menuOpened = false
    },
    toggleMenu () {
      this.menuOpened = !this.menuOpened
    }
  }
}
</script>

<style scoped lang="scss">
  @import "../../vars";
  .goods-wrapper {
    padding-top: 15px;
    width: 50%;
    margin: 0 auto;
    .go-to-top-button {
      position: fixed;
      bottom: 140px;
      right: 70px;
      opacity: 0;
      z-index: 7;
      transition: opacity .3s ease;
      &.shown {
        opacity: 1;
      }
    }
    .api-error {
      display: block;
      top: 50%;
      left: 50%;
      position: absolute;
      transform: translate(-50%, -50%);
      font-size: 24px;
      color: #F00;
    }
    .loading-message {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 24px;
      color: $tc;
    }

    .goods {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      padding-bottom: 20px;
    }
    .head {
      display: flex;
      justify-content: center;
      position: relative;
      padding: 5px 0;
      .filters {
        left: 0;
        position: absolute;
        width: 30px;
        height: 30px;
        background-color: #FFF;
        border: 1px solid $tc;
        border-radius: 50%;
        cursor: pointer;
        padding: 7px;
        svg {
          fill: $tc;
          height: 100%;
          width: 100%;
        }
      }
      .title {
        @include titleMixin;
      }

      .filters-wrapper {
        /*left: calc(25% - 15px);*/
        right: calc(20% - 15px);
        position: fixed;
        width: 30px;
        height: 30px;
        z-index: 8;
      }

      .nav {
        ul {
          transition: opacity .1s ease;
          transition-delay: .5s;
          padding: 20px 0;
          box-sizing: border-box;
          max-height: 100%;
          /*overflow-y: auto;*/
          /*overflow-x: hidden;*/
          margin: 0;
          li {
            text-align: left;
            padding: 10px 0;
            font-size: 24px;
            display: flex;
            align-items: center;
            &:hover {
              .category-name {
                &:before {
                  left: 0;
                }
              }
            }
            .mik-checkbox {
              width: 20px;
              height: 20px;
              position: relative;
              cursor: pointer;
              input {
                margin: 0;
                width: 100%;
                height: 100%;
                position: absolute;
                top: 0;
                left: 0;
                opacity: 0;
                box-sizing: border-box;
                display: block;
                &:checked {
                  & ~ .checkbox {
                    &:before {
                      opacity: 1;
                    }
                    /*&:hover {*/
                    /*  &:before {*/
                    /*    opacity: 0;*/
                    /*  }*/
                    /*}*/
                  }
                }
              }
              .checkbox {
                width: 100%;
                height: 100%;
                display: block;
                box-sizing: border-box;
                padding: 5px;
                border: 1px solid $btn-c;
                border-radius: 5px;
                position: relative;
                &:before {
                  content: '';
                  position: absolute;
                  display: inline-block;
                  width: 100%;
                  height: 100%;
                  top: 0;
                  left: 0;
                  border-radius: 2px;
                  background-color: $btn-c;
                  opacity: 0;
                }
                &:hover {
                  &:before {
                    opacity: 1;
                  }
                }
              }
            }
            .category-name {
              overflow: hidden;
              position: relative;
              display: inline-block;
              padding: 5px 0;
              margin-left: 10px;
              &:before {
                position: absolute;
                content: '';
                display: inline-block;
                height: 5px;
                width: 50px;
                background-color: $btn-c;
                top: 0;
                left: -50px;
                transition: left 0.3s ease;
              }
            }
          }
        }
        .menu-items {
          position: relative;
          list-style-type: none;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          font-size: 32px;
          z-index: 5;
          li {
            cursor: pointer;
          }
        }
      }

      .nav-tgl {
        display: inline-block;
        cursor: pointer;
        z-index: 100;
        width: 30px;
        height: 30px;
        border-radius: 50%;
        padding: 9px;
        background: #fff;
        border: 1px solid #2e2e2e;
        box-shadow: 0px 5px 15px -1px rgba(0, 0, 0, 0.24);
        line-height: 0.6;
        text-align: center;
        position: relative;

        > span {
          display: inline-block;
          position: relative;
          height: 1px;
          width: 80%;
          border-radius: 1px;
          background: #293335;
          vertical-align: middle;

          &:before, &:after {
            display: inline-block;
            position: absolute;
            content: "";
            height: 1px;
            border-radius: 1px;
            background: #293335;
            transition: all 200ms;
          }
          &:before {
            top: -7px;
            left: 3px;
            width: 60%;
          }
          &:after {
            top: 7px;
            left: 4px;
            width: 50%;
          }
        }

        &:focus {outline: none}
        &:hover {
          background-color: #2e2e2e;
          fill: #FFF;
        }
        &:hover > span:after, &:hover > span:before {
          width: 100%;
          left: 0;
          right: 0;
        }
      }

      .nav .bg {
        display: flex;
        position: fixed;
        top: 0;
        left: 0;
        content: '';
        width: 100vw;
        height: 100vh;
        overflow: auto;
        padding-bottom: 30px;
        box-sizing: border-box;
        background-image: url("../../assets/BG2.png");
        background-position: center;
        background-size: cover;
        transition: all 500ms ease-in-out;
        z-index: 4;
        clip-path: circle(16px at 80% 95px);
        visibility: hidden;
        .filters-buttons {
          position: fixed;
          bottom: 50px;
          right: 20%;
          width: 100px;
          z-index: 5;
          display: flex;
          justify-content: space-between;
          .filter-btn {
            border-radius: 50%;
            border: 1px solid #FFF;
            width: 40px;
            height: 40px;
            padding: 12px;
            box-sizing: border-box;
            cursor: pointer;
            svg {
              width: 100%;
              height: 100%;
              fill: $tc;
            }
            &:hover {
              background-color: $btn-c;
              border-color: $btn-c;
              svg {
                fill: #FFF;
              }
            }
            &.ok {
              background-color: $btn-c;
              border-color: $btn-c;
              svg {
                fill: #FFF;
              }
              &:hover {
                background-color: #FFF;
                border-color: #FFF;
                svg {
                  fill: $btn-c;
                }
              }
            }
          }
        }
      }

      .filters-wrapper.active {
        .nav .bg {
          visibility: visible;
          clip-path: circle(100%);
        }
        .nav {
          ul {
          }
        }

        .nav-tgl > span {
          height: 0;
          &:after, &:before {
            top: 0;
            left: 0;
            width: 100%;
          }
          &:after {
            transform: rotate(-45deg);
          }
          &:before {
            transform: rotate(45deg);
          }
        }
      }
    }
  }
  @media screen and (max-width: 550px){
    .goods-wrapper {
      width: 90%;
      .go-to-top-button {
        right: 40px;
        bottom: 50px;
      }
      .head {
        .filters-wrapper {
          right: calc(16% - 15px);
          &.active {
            /*top: 50px;*/
            /*right: 50px;*/
            /*left: unset;*/
          }
        }
        .nav {
          ul {
            width: 100%;
            padding: 20px;
            overflow: auto;
            li {
              font-size: 20px;
            }
          }
          .bg {
            padding-bottom: 75px;
            clip-path: circle(16px at 84% 95px);
            .filters-buttons {
              right: 40px;
            }
          }
        }
      }
      .goods {
        padding-bottom: 10px;
      }
    }
  }
</style>
